/* App block libraries must execute once even when Shopify also supplies a head asset. */
(() => {
  if (window.NetlagerAppScripts) return;
  const pending = new Map();
  const selector = 'template[data-netlager-viabill-script]';
  const isViaBill = url => url.hostname === 'cdn.shopify.com' && /\/viabill-payments[^/]*\/assets\/viabill\.js$/.test(url.pathname);
  function mount(scope = document) {
    const markers = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) markers.unshift(scope);
    for (const marker of markers) {
      let url;
      try { url = new URL(marker.dataset.src, document.baseURI); } catch (_) { continue; }
      if (url.protocol !== 'https:' || !isViaBill(url)) continue;
      // A parser/defer script may not have executed yet; its presence still owns this library.
      if ([...document.scripts].some(script => {
        try { return isViaBill(new URL(script.src, document.baseURI)); } catch (_) { return false; }
      }) || pending.has(url.href)) continue;
      const script = document.createElement('script');
      script.src = url.href;
      script.async = true;
      script.dataset.netlagerAppScript = 'viabill';
      pending.set(url.href, script);
      script.addEventListener('error', () => { pending.delete(url.href); script.remove(); }, { once: true });
      document.head.append(script);
    }
  }
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; mount(); });
  };
  const relevant = node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
  new MutationObserver(changes => {
    if (changes.some(change => [...change.addedNodes].some(relevant))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.NetlagerAppScripts = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
